import { useRef, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const DEFAULT_WIDTH = 1200;

export interface ContainerBreakpoints {
    isNarrow: boolean; // < 600px
    isMedium: boolean; // 600px - 900px
    isWide: boolean; // > 900px
    width: number;
    ref: React.RefObject<HTMLDivElement>;
}

export const useContainerWidth = (): ContainerBreakpoints => {
    const theme = useTheme();
    const ref = useRef<HTMLDivElement>(null);
    const isNarrow = useMediaQuery(theme.breakpoints.down('sm'));
    const isMedium = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const isWide = useMediaQuery(theme.breakpoints.up('md'));


    const [width, setWidth] = useState<number>(() => {
        if (typeof window !== 'undefined') {
            return window.innerWidth;
        }
        return DEFAULT_WIDTH;
    });

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return {
        isNarrow,
        isMedium,
        isWide,
        width,
        ref,
    };
};
